import { atom } from 'jotai';

export const isInsightsMenuOpenAtom = atom(false);
export const isBacklinksMenuOpenAtom = atom(false);
export const isActivityMenuOpenAtom = atom(false);
export const isAddOrShareMenuOpenAtom = atom(false);
